<template>
  <div class="mt-2">
    <h2>Profile Details</h2>
    <b-row>
      <b-col cols="12" xl="5">
        <b-form-group>
          <label><strong>Name</strong></label>
          <b-form-input type="text" placeholder="Name" v-model="authData.user.name" readonly></b-form-input>
        </b-form-group>

        <b-form-group>
          <label><strong>Email</strong></label>
          <b-form-input type="text" placeholder="Email" v-model="authData.user.email" readonly></b-form-input>
        </b-form-group>

        <b-form-group v-if="!authData.trial_user">
          <label><strong>Account Type</strong></label>
          <b-form-input type="text" placeholder="Full account" readonly value="Full account"></b-form-input>
        </b-form-group>

        <b-form-group v-if="authData.trial_user">
          <label><strong>Account Type</strong></label>
          <b-form-input type="text" placeholder="Trial" readonly v-model="trialExpirySting"></b-form-input>
        </b-form-group>

        <b-form-group>
          <label><strong>Organization</strong></label>
          <b-form-input type="text" placeholder="Organization" v-model="getOrganization" readonly></b-form-input>
        </b-form-group>
          <label>
            <strong>Products included in this account</strong>
          </label>
        <div v-for="(item, index) in getProductsFromPermissions" v-bind:key="`product_${index}`">
          <b-form-checkbox
            v-model="item.included"
            value=true
            unchecked-value=false disabled>
            {{ item.product }}
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-3">
      <b-col cols="12" xl="8">

        <div class="text-right">
          <b-button @click="logoutHandler">Logout</b-button>
        </div>

        <b-form-group v-if="authData.admin">
          <h3>Data only accessible by ADMINS</h3>
          <label><strong>Admin Data Access </strong></label>
          <b-form-textarea v-if="authData.admin"
                           v-model="userData"
                           rows="15"
                           placeholder="Empty"
                           readonly />
          <br>
          <label><strong>Bearer token (only valid for 1 day)</strong></label>
          <b-form-textarea v-model="authData.apiToken" :rows="15" placeholder="Empty" readonly /><br>
          <label><strong>Decoded JWT apiToken</strong></label>

          <pre>{{ decodedToken }}</pre>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from "moment";
  import jwt_decode from "jwt-decode";


  export default {
    name: 'common-settings',
    props: {
      authData: {
        type: Object,
        default: () => {}
      },
    },
    methods: {
      ...mapActions('api', ['logout']),
      async logoutHandler() {
        await this.logout();
      },
    },
    computed: {
      userData: {
        get: function() {
          if (this.authData) {
            return JSON.stringify(this.authData, null, 4);
          } else {
            return '';
          }
        },
        set: function() {
          console.warn('implement $emit to save this data when it will be required');
        },

      },
      getProductsFromPermissions: function() {
          
          if (this.authData && this.authData.user_authorization && this.authData.user_authorization.permissions) {
          let products = []

          products.push({product: "Congestion", included: this.authData.user_authorization.permissions.includes("read:congestion")})
          products.push({product: "Drydock Monitoring", included: this.authData.user_authorization.permissions.includes("read:drydock")})
          products.push({product: "Fleet Monitor", included: this.authData.user_authorization.permissions.includes("read:tradeflows")})
          products.push({product: "Tonnage Data", included: this.authData.user_authorization.permissions.includes("read:tonnage")})
          products.push({product: "Trade Flows", included: this.authData.user_authorization.permissions.includes("read:tradeflows")})
          products.push({product: "Full Api Access", included: this.authData.user_authorization.permissions.includes("apiaccess")})
          return products
        } else {
          return []
        }
      },
      trialExpirySting: function() {
          if (this.authData && this.authData.trial_expiry) {
            var ts = moment(this.authData.trial_expiry).format("DD MMMM YYYY")
            return "Trial account  (expires: " + ts + ")"
          } else {
            return "Trial account"
          }
      },
      getOrganization: function() {
        if (this.authData && this.authData.user['https://app.oceanbolt.com/organization']) {
          return this.authData.user['https://app.oceanbolt.com/organization']
        } else {
          if (this.authData && this.authData.user && this.authData.user.email) {
          let domain = this.authData.user.email.split('@').pop()
          return domain
          }

        }
      },
      decodedToken: function() {
        if (this.authData && this.authData.apiToken) {
          return jwt_decode(this.authData.apiToken)
        } else {
          return "No token to decode"
        }
      }
    },
  }
</script>

<style scoped>

</style>
